import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GlobalProductsApi } from '../globalProducts.api';

export const useCreateProduct = (businessPlanId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: GlobalProductsApi.createProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['globalProducts', businessPlanId] });
    },
  });
};
